AOS.init({
   duration: 1200,
})

function replaceWords() {
  $(".pro_var a span").each(function () {
    let text = $(this).text();
    text = text.replace(/\bColor\b/gi, "Colours")
               .replace(/\bColour\b/gi, "Colours")
               .replace(/\bSize\b/gi, "Sizes");
    $(this).text(text);
  });
}

// Run on page load
$(document).ready(function () {
  replaceWords();

  // Run again when Shopify collection/grid is updated
  $(document).on("shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect shopify:section:reorder ajaxComplete", function () {
    replaceWords();
  });
});

// Initialize slick slider with autoplay ON
  $('.bann_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true, // autoplay enabled
    autoplaySpeed: 6000,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0px'
        }
      }
    ]
  });

  // Play button
 $('#playSlider').on('click', function () {
    var slider = $('.bann_slider');

    slider.slick('slickPlay');       // start autoplay
    slider.slick('slickNext');       // instantly go to next slide
});


  // Pause button
  $('#pauseSlider').on('click', function(){
    $('.bann_slider').slick('slickPause');
  });


$('.our_logos').slick({
   slidesToShow: 10,
   slidesToScroll: 1,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 1500,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 2,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 3,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$('.product_card_slider').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   infinite: false,
   autoplay: true,
   autoplaySpeed: 1500,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1
         }
      }
   ]
});


$('.review-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   infinite: true,
   autoplay: false,
   autoplaySpeed: 1500,
   arrows: true,
   prevArrow: $('.prev-arrow'),
   nextArrow: $('.next-arrow'),
   dots: false,
   adaptiveHeight: true,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});



$('.video_box_slider').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   infinite: true,
   autoplay: true,
   autoplaySpeed: 1500,
   arrows: true,
   dots: false,
   responsive: [{
         breakpoint: 768,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      },
      {
         breakpoint: 480,
         settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px'
         }
      }
   ]
});


$('.cat_slider').slick({
    slidesToShow: 5, // how many buttons to show at a time
    slidesToScroll: 1,
    arrows: false, // weâ€™re using external arrows
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Custom arrows
  $('#catnext').click(function(){
    $('.cat_slider').slick('slickNext');
  });
  $('#catprev').click(function(){
    $('.cat_slider').slick('slickPrev');
  });



$('.three_box_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500, // wait 2 seconds before next slide
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });



$(document).ready(function(){

  // Initialize Slick
  $('.sin-proslid').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: false,
    dots: false,
    fade: true,            // 🔹 Enables fade transition
    cssEase: 'linear',     // 🔹 Smooth fade effect
    speed: 500,            // (Optional) Adjust fade speed
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // When clicking an offer
  $('.offer').on('click', function(e){
    let index = $(this).index();

    // Check if this is "Another Offer" (the last link)
    if ($(this).text().trim() === 'Another Offer') {
      // Let it go to its URL normally
      return;
    }

    // Stop redirect for the first 3
    e.preventDefault();

    // Change active state
    $('.offer').removeClass('active');
    $(this).addClass('active');

    // Go to that slide
    $('.sin-proslid').slick('slickGoTo', index);
  });

});




$(".custom-tabs button").click(function(){
      $(".custom-tabs button").removeClass("active");
      $(this).addClass("active");
      $(".tab-pane").removeClass("show");
      $($(this).data("target")).addClass("show");
    });

// Image change on click
  $(".thumb").click(function(){
    $(".thumb").removeClass("active");
    $(this).addClass("active");
    $("#mainImage").attr("src", $(this).data("img"));
  });

  // Quantity +/- buttons
  $(".plus").click(function(){
    let input = $(this).siblings("input");
    input.val(parseInt(input.val())+1);
    updateSubtotal();
  });
  $(".minus").click(function(){
    let input = $(this).siblings("input");
    let val = parseInt(input.val());
    if(val>0) input.val(val-1);
    updateSubtotal();
  });

  // Buy it with Logo toggle
  $("input[name='buyType']").change(function(){
    if($("#logo").is(":checked")){
      $(".logo-upload, .remarks, .rem_botbtns").removeClass("d-none");
    } else {
      $(".logo-upload, .remarks, .rem_botbtns").addClass("d-none");
    }
  });

  // Subtotal calculation
  function updateSubtotal(){
    let qty = 0;
    $(".qty-box input").each(function(){ qty += parseInt($(this).val()); });
    let price = 11.69;
    let total = qty * price;
    $("#subtotal").text("$"+total.toFixed(2));
  }

  $(document).ready(function(){
  // Init slick on left & right thumbs
  $(".thumb-left .thumbs, .thumb-right .thumbs").slick({
    vertical: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: $(".thumb-left .prev, .thumb-right .prev"),
    nextArrow: $(".thumb-left .next, .thumb-right .next")
  });

  // Click on thumbnail -> change main image
  $(".thumbs img").click(function(){
    $("#mainImage").attr("src", $(this).data("img"));
    $(".thumbs img").removeClass("active");
    $(this).addClass("active");
  });
});

// $(document).ready(function(){
//   $(".pro_exctext").click(function(){
//     $(this).toggleClass("expanded");
//   });
// });


$(document).ready(function () {
  var maxWords = 200; // show first 200 words

  $('.pro_exctext p').each(function () {
    var fullText = $(this).text().trim();
    var words = fullText.split(/\s+/);

    if (words.length > maxWords) {
      var visibleText = words.slice(0, maxWords).join(' ');
      var hiddenText = words.slice(maxWords).join(' ');

      // replace paragraph content
      $(this).html(`
        <span class="visible-text">${visibleText}</span>
        <span class="more-text" style="display:none;"> ${hiddenText}</span>
        <div style="cursor: pointer;" class="toggle-text" style="color:#007bff;cursor:pointer;display:block;margin-top:5px;">See More</div>
      `);
    }
  });

  // toggle button click event
  $(document).on('click', '.toggle-text', function () {
    var $this = $(this);
    var $moreText = $this.siblings('.more-text');

    if ($moreText.is(':visible')) {
      $moreText.slideUp(300);
      $this.text('See More');
    } else {
      $moreText.slideDown(300);
      $this.text('See Less');
    }
  });
});


  $(document).ready(function(){
    // Add active class to the first option by default
    $('.buy_op_btn').first().addClass('active');

    $('.buy_op_btn').click(function(){
      $('.buy_op_btn').removeClass('active');
      $(this).addClass('active');
    });
  });


// Back to top
// Show/Hide Button on Scroll
$(window).scroll(function () {
  if ($(this).scrollTop() > 200) { // Show after 200px scroll
    $('.back-to-top').fadeIn();
  } else {
    $('.back-to-top').fadeOut();
  }
});

// Smooth Scroll to Top
$('.back-to-top').click(function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 600); // 600ms scroll speed
});


$(document).ready(function() {
  $('.color-swatch').on('click', function() {
    var newImage = $(this).data('image');  // Get variant image URL
    var mainImage = $('#mainImage');       // Main image ID

    if (newImage && mainImage.length) {
      mainImage.attr('src', newImage);     // Update main image
    }

    // Add active class for visual highlight
    $('.color-swatch').removeClass('active');
    $(this).addClass('active');
  });
});


$(document).ready(function() {
  $('.color-swatch').on('click', function() {
    var newImage = $(this).data('image');
    var newPrice = parseFloat($(this).data('price')) || 0;
    var newCompare = parseFloat($(this).data('compare')) || 0;
    var mainImage = $('#mainImage');
    var priceWrap = $('.price');

    // Change main image
    if (newImage && mainImage.length) {
      mainImage.attr('src', newImage);
    }

    // Format price to 2 decimals
    var formattedPrice = '$' + newPrice.toFixed(2);
    var formattedCompare = '$' + newCompare.toFixed(2);

    // Update prices dynamically
    if (priceWrap.length) {
      if (newCompare > newPrice) {
        priceWrap.html(
          '<span class="new-price">' + formattedPrice + '</span> ' +
          '<span class="old-price">' + formattedCompare + '</span> each item'
        );
      } else {
        priceWrap.html('<span class="new-price">' + formattedPrice + '</span> each item');
      }
    }

    // Active swatch
    $('.color-swatch').removeClass('active');
    $(this).addClass('active');
  });
});




jQuery(document).ready(function($) {
  const $mainBox = $('#mainprobox');
  const $mainImage = $mainBox.find('#mainImage');
  const $thumbs = $mainBox.find('.thumb-item img');
  const $thumbnails = $mainBox.find('.thumbnails');
  const $prevBtn = $mainBox.find('.thumb-arrow.prev');
  const $nextBtn = $mainBox.find('.thumb-arrow.next');

  let scrollIndex = 0;
  const visibleThumbs = 5; // Show 5 thumbs
  // const thumbWidth = 73; // (65px width + 8px gap)
  const thumbWidth = 115; // (65px width + 8px gap)

  // ✅ Set first thumbnail active
  $thumbs.first().addClass('active');

  // ✅ Click thumbnail → Change main image
  $thumbs.on('click', function() {
    const $this = $(this);
    const newSrc = $this.data('large');

    $thumbs.removeClass('active');
    $this.addClass('active');

    $mainImage.fadeOut(200, function() {
      $mainImage.attr('src', newSrc).fadeIn(200);
    });
  });

  // ✅ Scroll thumbnails using arrows
  function updateScroll() {
    const translateX = -(scrollIndex * thumbWidth);
    $thumbnails.css('transform', `translateX(${translateX}px)`);
  }

  $nextBtn.on('click', function() {
    const maxIndex = $thumbs.length - visibleThumbs;
    if (scrollIndex < maxIndex) {
      scrollIndex++;
      updateScroll();
    }
  });

  $prevBtn.on('click', function() {
    if (scrollIndex > 0) {
      scrollIndex--;
      updateScroll();
    }
  });
});


$(document).ready(function () {
  // Thumbnail click: change main image
  $(".product-gallery").each(function () {
    const gallery = $(this);

    gallery.find(".thumb").on("click", function () {
      const newSrc = $(this).attr("src");
      gallery.find(".main-image img").attr("src", newSrc);
      gallery.find(".thumb").removeClass("active");
      $(this).addClass("active");
    });

    // Thumbnail scroll functionality
    const thumbContainer = gallery.find(".thumbnails");
    const thumbWidth = gallery.find(".thumb").outerWidth(true);
    const scrollAmount = thumbWidth * 2; // scroll 2 thumbs at once

    gallery.find(".arrow.next").on("click", function () {
      thumbContainer.animate({ scrollLeft: "+=" + scrollAmount }, 300);
    });

    gallery.find(".arrow.prev").on("click", function () {
      thumbContainer.animate({ scrollLeft: "-=" + scrollAmount }, 300);
    });
  });

  // Offer sub-slider independent functionality
  $(".offer-container").each(function () {
    const offerBox = $(this);
    const slider = offerBox.find(".offer-slider");
    const scrollAmount = 150;

    offerBox.find("#next").on("click", function () {
      slider.animate({ scrollLeft: "+=" + scrollAmount }, 300);
    });

    offerBox.find("#prev").on("click", function () {
      slider.animate({ scrollLeft: "-=" + scrollAmount }, 300);
    });

    offerBox.find(".offer").on("click", function () {
      offerBox.find(".offer").removeClass("active");
      $(this).addClass("active");
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const categoryLinks = document.querySelectorAll('.category-btns .nav-link');
  const tabPanes = document.querySelectorAll('.tab-content .tab-pane');

  categoryLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default anchor behavior

      // Remove 'active' class from all links
      categoryLinks.forEach(l => l.classList.remove('active'));

      // Add 'active' to clicked link
      this.classList.add('active');

      // Get target tab content ID
      const target = this.getAttribute('href');

      // Hide all tab panes
      tabPanes.forEach(pane => {
        pane.classList.remove('show', 'active');
      });

      // Show the selected tab pane
      const activePane = document.querySelector(target);
      if(activePane){
        activePane.classList.add('show', 'active');
      }
    });
  });
});


const mainImage = document.getElementById('mainImage');
const thumbs = document.querySelectorAll('.thumb-gallery .thumb');
thumbs.forEach(t => {
   t.addEventListener('click', () => {
      // change main image
      mainImage.src = t.src;
      // active state
      thumbs.forEach(i => i.classList.remove('active'));
      t.classList.add('active');
   });
});

// Scroll thumbnails with arrows
// document.querySelector('.prev').onclick = () => {
//    document.querySelector('.thumbnails').scrollBy({
//       left: -100,
//       behavior: 'smooth'
//    });
// };
// document.querySelector('.next').onclick = () => {
//    document.querySelector('.thumbnails').scrollBy({
//       left: 100,
//       behavior: 'smooth'
//    });
// };

const prevBtn = document.querySelector('.prev');
const nextBtn = document.querySelector('.next');
const thumbsContainer = document.querySelector('.thumbnails');

if(prevBtn && nextBtn && thumbsContainer){

  prevBtn.onclick = () => {
    thumbsContainer.scrollBy({
      left: -100,
      behavior: 'smooth'
    });
  };

  nextBtn.onclick = () => {
    thumbsContainer.scrollBy({
      left: 100,
      behavior: 'smooth'
    });
  };

}

document.addEventListener("DOMContentLoaded", () => {

const mainImageBox = document.querySelector('.main-image');

if (!mainImageBox) return; // stop if element doesn't exist

const mainImg = mainImageBox.querySelector('img');

mainImageBox.addEventListener('mousemove', e => {
   const rect = mainImageBox.getBoundingClientRect();
   const x = ((e.clientX - rect.left) / rect.width) * 100;
   const y = ((e.clientY - rect.top) / rect.height) * 100;
   mainImg.style.transformOrigin = `${x}% ${y}%`;
   mainImg.style.transform = 'scale(2)';
});

mainImageBox.addEventListener('mouseleave', () => {
   mainImg.style.transformOrigin = 'center center';
   mainImg.style.transform = 'scale(1)';
});

});


// const slider = document.querySelector('.offer-slider');
// const offers = document.querySelectorAll('.offer');

// offers.forEach(btn => {
//    btn.addEventListener('click', () => {
//       offers.forEach(b => b.classList.remove('active'));
//       btn.classList.add('active');
//       console.log('Clicked:', btn.textContent); // your action here
//    });
// });

// document.getElementById('next').addEventListener('click', () => {
//    slider.scrollBy({
//       left: 150,
//       behavior: 'smooth'
//    });
// });

// document.getElementById('prev').addEventListener('click', () => {
//    slider.scrollBy({
//       left: -150,
//       behavior: 'smooth'
//    });
// });


document.addEventListener("DOMContentLoaded", () => {

const slider = document.querySelector('.offer-slider');
const offers = document.querySelectorAll('.offer');

offers.forEach(btn => {
   btn.addEventListener('click', () => {
      offers.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      console.log('Clicked:', btn.textContent);
   });
});

const nextBtn = document.getElementById('next');
const prevBtn = document.getElementById('prev');

if(nextBtn && slider){
   nextBtn.addEventListener('click', () => {
      slider.scrollBy({
         left: 150,
         behavior: 'smooth'
      });
   });
}

if(prevBtn && slider){
   prevBtn.addEventListener('click', () => {
      slider.scrollBy({
         left: -150,
         behavior: 'smooth'
      });
   });
}

});


document.addEventListener('DOMContentLoaded', function() {
   const buyTypeRadios = document.querySelectorAll('input[name="buyType"]');
   const logoUpload = document.querySelector('.logo-upload');
   const remarks = document.querySelector('.remarks');
   const remBotBtns = document.querySelector('.rem_botbtns');

   const colorSwatches = document.querySelectorAll('.color-swatch');
   const qtyBoxes = document.querySelectorAll('.qty-box');
   const totalQty = document.getElementById('total_qty');
   const variationCount = document.getElementById('variation_count');
   const qtyCount = document.getElementById('qty_count');
   const savedAmount = document.getElementById('saved_amount');
   const selectedVariant = document.getElementById('selected_variant');

   let selectedColor = '';
   let totalQuantity = 0;

   // Show/Hide logo and remarks based on buy type
   buyTypeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
         if(this.value === 'logo') {
            logoUpload.classList.remove('d-none');
            remarks.classList.remove('d-none');
            remBotBtns.classList.remove('d-none');
         } else {
            logoUpload.classList.add('d-none');
            remarks.classList.add('d-none');
            remBotBtns.classList.add('d-none');
         }
      });
   });

   // Color selection
   colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
         colorSwatches.forEach(s => s.classList.remove('active'));
         this.classList.add('active');
         selectedColor = this.dataset.color;
         updateVariant();
      });
   });

   // Quantity buttons
   qtyBoxes.forEach(box => {
      const input = box.querySelector('input');
      const plus = box.querySelector('.plus');
      const minus = box.querySelector('.minus');

      plus.addEventListener('click', () => {
         input.value = parseInt(input.value) + 1;
         updateTotals();
         updateVariant();
      });

      minus.addEventListener('click', () => {
         if(parseInt(input.value) > 0) {
            input.value = parseInt(input.value) - 1;
            updateTotals();
            updateVariant();
         }
      });
   });

   function updateTotals() {
      let qty = 0;
      let variations = 0;
      qtyBoxes.forEach(box => {
         const val = parseInt(box.querySelector('input').value);
         if(val > 0) variations += 1;
         qty += val;
      });
      // totalQty.innerText = qty;
      // variationCount.innerText = variations;
      // qtyCount.innerText = qty;
      // savedAmount.innerText = (qty * 5).toFixed(2); // Example saved amount

      if(totalQty) totalQty.innerText = qty;
      if(variationCount) variationCount.innerText = variations;
      if(qtyCount) qtyCount.innerText = qty;
      if(savedAmount) savedAmount.innerText = (qty * 5).toFixed(2);
   }

   function updateVariant() {
      let found = false;
      qtyBoxes.forEach(box => {
         const boxColor = box.dataset.color;
         const qty = parseInt(box.querySelector('input').value);
         if(boxColor === selectedColor && qty > 0) {
            selectedVariant.value = box.dataset.variantId;
            found = true;
         }
      });
      if(!found) {
         // fallback to first variant
         selectedVariant.value = document.querySelector('.qty-box').dataset.variantId;
      }
   }
});



(function(){
  function normalize(s){
    if(!s) return '';
    // replace NBSP, collapse whitespace, trim, lowercase
    return s.replace(/\u00A0/g,' ').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function checkAndRemove(root){
    root.querySelectorAll('.pro_var a').forEach(a=>{
      const span = a.querySelector('span');
      const raw = span ? span.textContent : a.textContent;
      const txt = normalize(raw);
      // match "1 size" or "1 sizes" (with any spacing/casing)
      if (txt === '1 size' || txt === '1 sizes') {
        a.remove();
        console.log('Removed element because text ==', JSON.stringify(raw));
      }
    });
  }

  checkAndRemove(document);

  const mo = new MutationObserver(muts=>{
    muts.forEach(m=>{
      // if new nodes added or subtree changed, check the added node(s)
      if (m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(node=>{
          if (node.nodeType === 1) checkAndRemove(node); // element
        });
      }
      // also if text inside existing elements changed
      if (m.type === 'characterData' || m.type === 'attributes') {
        checkAndRemove(document);
      }
    });
  });

  mo.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true });
  
  setInterval(()=>checkAndRemove(document), 1500);
})();


document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(
      ".slide_rating_box, .rating-info, .rat_info"
    );

    elements.forEach(function (el) {
      el.style.cursor = "pointer"; 
      el.addEventListener("click", function () {
        window.location.href = "https://madhats.com.au/pages/testimonial";
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT
  );

  const regex = /21,000\+\s*Happy\s*Customers/gi;
  let node;

  while (node = walker.nextNode()) {
    if (regex.test(node.nodeValue)) {
      node.nodeValue = node.nodeValue.replace(regex, "21,000+ Customers");
    }
  }
});

